import axios from 'axios'
import qs from 'qs'


export function postPage(data) {
    return axios({
        url: `/api/auth/page`,
        method: 'post',
        data: qs.stringify(data)
    })
}

export function getDetails(id) {
    return axios({
        url: `/api/auth/${id}`,
        method: 'get',
    })
}
// js-sdk授权
export function config(data) {
    return axios({
        url: `/api/wx/sdk/config`,
        method: 'post',
        data: qs.stringify(data)
    })
}